import { Add } from '@mui/icons-material'
import { Avatar, Chip, Dialog, DialogContent, Icon, IconButton } from '@mui/material'
import React, { useState,useEffect } from 'react'
import { useChatConversationProvider } from '../../../context/ConversationContext'
import cmsServices from '../../cmsServices';

const colorList = [
    "primary",
    "secondary",
    "error",
    "info",
    "success",
    "warning",
]


function SuggestionList({sendSuggestionMessageId,openMainMenu}) {
    const {conversationList} = useChatConversationProvider();
    const [dialogStatus,setDialogStatus]  = useState(false);
    const [suggestionList,setSeggestionList] = useState([])
    const getSuggestionList = () =>{
        cmsServices.getSuggestionList().then(res=>{
            setSeggestionList(res.data)
        }).catch(error=>{
        })
    }
    useEffect(()=>{
        getSuggestionList();
    },[])

    const [showList,setShowList] = useState(true);

    useEffect(()=>{
        if(conversationList.length>1){
            setShowList(false);
        }
    },[conversationList])

    const handleMainMenuButton = () =>{
        setTimeout(()=>{
            setShowList(true);
        },4000)
        openMainMenu()
    }

    const [buttonColor,setButtonColor] = useState(0);

    

    useEffect(()=>{
        const myinterval = setInterval(()=>{
            setButtonColor(buttonColor=>buttonColor===colorList.length-1?0:buttonColor+1)
        },1000)
        return ()=>{
            clearInterval(myinterval)
        }
    },[])

    const sendSuggestion = (option) =>{
        sendSuggestionMessageId(option);
        setDialogStatus(false);
    }

    return (
        <>
        {showList && suggestionList &&
            <div className='d-flex justify-content-start'>
                {suggestionList.map((option,i)=>
                    i<2 &&
                    <Chip variant={option.variant} color={option.color} className='mt-1 me-1' key={i} onClick={()=>{sendSuggestion(option)}} label={option.optionTitle} />
                )}
                {suggestionList.length > 2 &&
                    <div >
                        <IconButton color={colorList[buttonColor]} onClick={()=>setDialogStatus(true)}  >
                            <i className='fa fa-plus fa-beat-fade'></i>
                        </IconButton>
                        <Dialog
                            open={dialogStatus}
                            keepMounted
                            onClose={()=>setDialogStatus(false)}
                            fullWidth={true}
                        >
                            <DialogContent>
                                {suggestionList.map((option,i)=>
                                    i>=2 &&
                                    <Chip variant={option.variant} color={option.color} className='mt-1 me-1' key={i} onClick={()=>{sendSuggestion(option)}} label={option.optionTitle} />
                                )}
                            </DialogContent>
                        </Dialog>
                        {/*
                        <ul className="dropdown-menu" style={{zIndex:10001}}>
                            {suggestionList && suggestionList.map((option,i)=>
                                i >=2 && <li key={i}><span role="button" className="dropdown-item" onClick={()=>{sendSuggestionMessageId(option)}} >{option.optionTitle}</span> </li>
                            )}
                        </ul>
                        */}
                    </div>
                }
            </div>
        }
        {!showList && <Chip className='mt-1' onClick={handleMainMenuButton} label={"Go To Main Menu"} />}
        </>
    )
}

export default SuggestionList